import styled from 'styled-components';
import { colors } from '../../../theme/style-helpers';

const QuestionBoxContainer = styled('div')`
    margin-bottom: 72px;

    h2 {
        font-family: Montserrat;
        font-size: 28px;
        line-height: 36.4px;
        font-weight: 500;
    }

    p {
        font-size: 18px;
    }

    a, button{
        font-family: Montserrat;
        font-size: 18px;
        text-decoration: underline;
        text-underline-offset: 2px;
        font-weight: 600;
        background-color: transparent;
        border: none;
        cursor: pointer;
        margin: 0;
        padding: 0;
        color: ${colors.BLACK};

        &:hover {
            text-decoration: underline;
            text-underline-offset: 2px;
            text-decoration-color: ${colors.BRAND_ORANGE};
            color: ${colors.BLACK};
        }

        &:focus {
            outline: none;
            background-color: rgba(255, 95, 20, 0.1);
            text-decoration: underline;
            text-underline-offset: 2px;
            text-decoration-color: ${colors.BRAND_ORANGE};
        }
    }
`;

export default QuestionBoxContainer;
